"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgPriceAlert1 = function SvgPriceAlert1(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 209 73",
    role: "img"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#007AFF",
    d: "m0 25.99 39.484 4.76 39.184-15.368 39.716 5.789 39-20.171 50.562 71.132"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(166 19)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 17.5,
    fill: "#A2E9C6",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#17181A",
    transform: "rotate(10 -35.144 69.307)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M7.436 2.25c-2.68.164-4.098 1.746-4.257 4.745-.159 2.999-1.05 4.832-2.673 5.5-.605.562-.605 1.024 0 1.386.908.543 3.604 1.176 6.93 1.176h.07c3.326 0 6.022-.633 6.93-1.176.605-.362.605-.824 0-1.387-1.623-.667-2.514-2.5-2.673-5.5-.16-2.998-1.578-4.58-4.257-4.745h-.07z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M5.04 15.011a2.932 2.932 0 0 0-.076.707 2.482 2.482 0 1 0 4.963 0 2.91 2.91 0 0 0-.104-.739c-.755.082-1.547.123-2.378.123-.83 0-1.632-.03-2.405-.09z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.445,
    cy: 0.827,
    r: 1
  })))));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgPriceAlert1);
var _default = exports["default"] = Memo;